import { getDocs, collection, doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from '../../../firebase/config';
import { fetchCompanyBankId } from "../../companies/service/companiesService";

export type Manager = {
    id: string;
    name: string;
    mobile?: string;
    email?: string;
    type?: string;
    createdAt?: any;
    updatedAt?: any;
};

export async function fetchManagers(bankId: string): Promise<Manager[]> {
    const mgrSnap = await getDocs(collection(db, "banks", bankId, "managers"));
    const managerList: Manager[] = mgrSnap.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    } as Manager));

    // Sort by name
    managerList.sort((a, b) => {
        const nameA = a.name || '';
        const nameB = b.name || '';
        return nameA.localeCompare(nameB);
    });

    console.log('Fetched Managers:', managerList.length);

    return managerList;
}

export async function updateManager(bankId: string, managerId: string, data: Partial<Manager>): Promise<void> {
    const managerRef = doc(db, "banks", bankId, "managers", managerId);
    const updateData = { ...data, updatedAt: new Date() };
    await updateDoc(managerRef, updateData);
}

export async function fetchManagerBankId(uid: string, isBankUser: boolean = false): Promise<string | null> {
    return await fetchCompanyBankId(uid, isBankUser);
}

